import React, { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import 'leaflet/dist/leaflet.css';
import 'leaflet-fullscreen';
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';

export const FullscreenControl = () => {
    const map = useMap();
  
    useEffect(() => {
      // Initialize fullscreen control
      const fullscreenControl = L.control.fullscreen({
        position: 'bottomright', // Position the fullscreen control
      }).addTo(map);
    
      // Cleanup function to remove the control when the component is unmounted
      return () => {
        map.removeControl(fullscreenControl);
      };
    }, [map]);
    
  
    return null;
  };